import React from 'react';
import { PRIMARY_COLOR } from '../constants';

class Logo extends React.Component{

  render(){
    return (
      <svg
        id="svg48"
        style={this.props.style}
        version="1.1"
        viewBox="0 0 522.64 136.9">
        <metadata
          id="metadata52">
          
        </metadata>
        <defs
          id="defs12">
          <filter
            height="1.053503"
            y="-0.02675148"
            width="1.0545064"
            x="-0.02725318"
            id="filter1260">
            <feGaussianBlur
              id="feGaussianBlur1262"
              stdDeviation="0.86585625" />
          </filter>
          <filter
            height="1.0501784"
            y="-0.025089214"
            width="1.0584517"
            x="-0.029225829"
            id="filter1280">
            <feGaussianBlur
              id="feGaussianBlur1282"
              stdDeviation="0.78215625" />
          </filter>
          <filter
            height="1.0460394"
            y="-0.023019681"
            width="1.0652891"
            x="-0.03264455"
            id="filter1300"
            >
            <feGaussianBlur
              id="feGaussianBlur1302"
              stdDeviation="1.0332"
               />
          </filter>
          <filter
            height="1.0432925"
            y="-0.02164624"
            width="1.0717446"
            x="-0.035872284"
            id="filter1320"
            >
            <feGaussianBlur
              id="feGaussianBlur1322"
              stdDeviation="0.6741"
               />
          </filter>
          <filter
            height="1.0451042"
            y="-0.022552083"
            width="1.067267"
            x="-0.033633487"
            id="filter1340"
            >
            <feGaussianBlur
              id="feGaussianBlur1342"
              stdDeviation="0.97425"
               />
          </filter>
          <filter
            height="1.0594143"
            y="-0.029707174"
            width="1.04949"
            x="-0.02474502"
            id="filter897"
            >
            <feGaussianBlur
              id="feGaussianBlur899"
              stdDeviation="0.71111621"
               />
          </filter>
          <filter
            height="1.037074"
            y="-0.018537016"
            width="1.0993643"
            x="-0.049682139"
            id="filter944"
            
            >
            <feGaussianBlur
              id="feGaussianBlur946"
              stdDeviation="0.32897384"
               />
          </filter>
          <filter
            height="1.0360779"
            y="-0.018038954"
            width="1.1073049"
            x="-0.053652425"
            id="filter983"
            
            >
            <feGaussianBlur
              id="feGaussianBlur985"
              stdDeviation="0.32014293"
               />
          </filter>
          <filter
            height="1.1243565"
            y="-0.06217824"
            width="1.0344879"
            x="-0.017243973"
            id="filter1002"
            
            >
            <feGaussianBlur
              id="feGaussianBlur1004"
              stdDeviation="0.45772164"
               />
          </filter>
          <filter
            height="1.0699614"
            y="-0.034980701"
            width="1.0439687"
            x="-0.02198436"
            id="filter1098"
            
            >
            <feGaussianBlur
              id="feGaussianBlur1100"
              stdDeviation="0.47255075"
               />
          </filter>
          <filter
            height="1.0220699"
            y="-0.011034963"
            width="1.1024044"
            x="-0.051202216"
            id="filter1171"
            
            >
            <feGaussianBlur
              id="feGaussianBlur1173"
              stdDeviation="0.1959426"
               />
          </filter>
          <filter
            height="1.0098822"
            y="-0.004941083"
            width="1.0265001"
            x="-0.013250064"
            id="filter1188"
            
            >
            <feGaussianBlur
              id="feGaussianBlur1190"
              stdDeviation="0.087736468"
               />
          </filter>
        </defs>
        <g
          id="g1117">
          <g
            id="g1096"
            style={{filter: 'url(#filter1098)', opacity: 0.2}}>
            <path
              style={{fill: '#000000', fillOpacity: 1, strokeWidth: 0.965963}}
              d="m 320.43767,84.439834 v 9.350523 l -1.20746,-3.313253 a 44.830351,44.830351 0 0 0 -5.6219,-9.881804 30.456819,30.456819 0 0 0 -7.48622,-7.012892 l -2.15409,3.458148 a 0.50230085,0.50230085 0 0 1 -0.88869,0 l -8.38456,-15.107664 c -0.15456,-0.280129 0.0676,-0.637535 0.34775,-0.550599 l 15.01106,4.46275 a 0.64719532,0.64719532 0 0 1 0.30911,0.965963 l -2.08648,3.351893 a 32.717173,32.717173 0 0 1 7.56349,6.877657 36.7066,36.7066 0 0 1 4.59799,7.399278 z"
              id="path14-9" />
            <path
              id="path14-9-8"
              d="m 320.438,84.439834 v 9.350523 l 1.20746,-3.313253 a 44.830351,44.830351 0 0 1 5.6219,-9.881804 30.456819,30.456819 0 0 1 7.48622,-7.012892 l 2.15409,3.458148 a 0.50230085,0.50230085 0 0 0 0.88869,0 l 8.38456,-15.107664 c 0.15456,-0.280129 -0.0676,-0.637535 -0.34775,-0.550599 l -15.01106,4.46275 a 0.64719532,0.64719532 0 0 0 -0.30911,0.965963 l 2.08648,3.351893 a 32.717173,32.717173 0 0 0 -7.56349,6.877657 36.7066,36.7066 0 0 0 -4.59799,7.399278 z"
              style={{fill: '#000000', fillOpacity: 1, strokeWidth: 0.965963}} />
          </g>
          <g
            id="g1017">
            <path
              style={{fill: '#000000', fillOpacity: 1, strokeWidth: 0.965963, filter: 'url(#filter1002)', opacity: 0.2}}
              d="m 300.56308,46.28964 a 28.978895,28.978895 0 0 1 37.33448,0 35.740637,35.740637 0 0 1 13.20471,2.965507 C 344.90079,38.388062 333.40583,31.607 319.22549,31.607 c -14.18034,0 -25.69462,6.82936 -31.82849,17.667466 a 35.586083,35.586083 0 0 1 13.16608,-2.984826 z"
              id="path18-4" />
            <g
              style={{filter: 'url(#filter983)', opacity: 0.2}}
              transform="translate(-2,2.0001555)"
              id="g972">
              <g
                id="g981">
                <path
                  style={{fill: '#000000', fillOpacity: 1, strokeWidth: 0.965963}}
                  d="m 366.33559,59.416143 -3.69964,-2.772314 a 0.29944858,0.29944858 0 0 0 -0.48298,0.289789 84.038796,84.038796 0 0 1 1.34269,16.363416 85.593996,85.593996 0 0 1 -2.13478,19.010155 0.29944858,0.29944858 0 0 0 0.44434,0.328428 c 1.21712,-0.676174 2.06716,-1.31371 3.24564,-1.989884 a 0.59889717,0.59889717 0 0 0 0.30911,-0.376726 62.95182,62.95182 0 0 0 2.49218,-17.126527 64.101316,64.101316 0 0 0 -1.32337,-13.407569 0.50230085,0.50230085 0 0 0 -0.19319,-0.318768 z"
                  id="path29-4" />
                <path
                  style={{fill: '#000000', fillOpacity: 1, strokeWidth: 0.965963}}
                  className="cls-1"
                  d="m 358.18286,94.499926 c 0.82107,-0.386386 2.52117,-1.217114 3.1104,-1.526222 a 0.41536416,0.41536416 0 0 0 0.1932,-0.251151 57.95779,57.95779 0 0 0 1.362,-7.322 75.847428,75.847428 0 0 0 1.03358,-10.925044 79.527748,79.527748 0 0 0 -1.53588,-17.995894 0.33808711,0.33808711 0 0 0 -0.16421,-0.231831 c -0.49264,-0.26081 -1.09154,-0.540939 -1.59384,-0.801749 -0.5023,-0.260811 -0.96596,-0.492642 -1.42963,-0.714813 a 83.072833,83.072833 0 0 1 1.93193,19.782926 80.445413,80.445413 0 0 1 -3.23598,19.618712 c -0.0676,0.26081 0.0966,0.473322 0.32843,0.367066 z"
                  id="path31-8" />
                <path
                  style={{fill: '#000000', fillOpacity: 1, strokeWidth: 0.965963}}
                  d="m 354.049,92.393514 c 0.017,0.435347 0.13889,2.035095 0.54836,2.183917 0.70992,0.341364 -0.36042,1.314319 0.4268,1.342461 0.9891,0.0784 1.98263,-0.08057 2.89789,-0.463663 0.36274,-0.168141 0.63919,-0.479587 0.76311,-0.859707 1.45701,-6.036203 2.29528,-12.205136 2.50185,-18.411258 0.24959,-7.125918 -0.32413,-14.256833 -1.70976,-21.25119 v -0.183533 c -0.0512,-0.122952 -0.13065,-0.232143 -0.23183,-0.318768 -0.90294,-0.802705 -2.102,-1.188368 -3.30359,-1.062559 -1.21462,0.02335 -0.84071,0.482778 -1.74467,1.29439 0,0 -0.2744,1.354162 -0.26452,1.50543 0.43468,6.143526 0.32628,11.480776 0.3939,18.570946 -0.0483,6.80038 0.0605,11.625924 -0.27754,17.653534 z"
                  id="path33-3" />
              </g>
            </g>
            <g
              style={{filter: 'url(#filter944)', opacity: 0.2}}
              id="g942">
              <g
                style={{filter: 'url(#filter1188)', opacity: 0.64692483}}
                id="g1178">
                <path
                  style={{fill: '#000000', fillOpacity: 1, strokeWidth: 0.965963, opacity: 0.9476082}}
                  d="m 274.29821,61.4163 3.69964,-2.772314 a 0.29944858,0.29944858 0 0 1 0.48299,0.289789 84.830886,84.830886 0 0 0 -1.37167,16.363416 86.173574,86.173574 0 0 0 2.13478,19.010155 0.29944858,0.29944858 0 0 1 -0.44435,0.328428 c -1.20745,-0.676174 -2.0575,-1.31371 -3.24563,-1.989884 a 0.63753569,0.63753569 0 0 1 -0.30911,-0.376726 63.46378,63.46378 0 0 1 -1.15916,-30.563075 0.44434306,0.44434306 0 0 1 0.21251,-0.289789 z"
                  id="path23-2" />
                <path
                  style={{fill: '#000000', fillOpacity: 1, strokeWidth: 0.965963, opacity: 0.91343964}}
                  className="cls-1"
                  d="m 282.45094,96.500083 c -0.82107,-0.386386 -2.5115,-1.217114 -3.1104,-1.526222 a 0.40570453,0.40570453 0 0 1 -0.18353,-0.251151 59.570949,59.570949 0 0 1 -1.37167,-7.322 74.900784,74.900784 0 0 1 -1.02392,-10.925044 78.407231,78.407231 0 0 1 1.53588,-17.995894 0.32842748,0.32842748 0 0 1 0.15456,-0.231831 c 0.49264,-0.26081 1.10119,-0.54094 1.6035,-0.80175 0.5023,-0.26081 0.96596,-0.492641 1.41996,-0.714812 a 82.62849,82.62849 0 0 0 -1.93193,19.782926 79.98175,79.98175 0 0 0 3.23598,19.618712 c 0.12558,0.26081 -0.0966,0.473322 -0.32843,0.367066 z"
                  id="path25-3" />
                <path
                  style={{fill: '#000000', fillOpacity: 1, strokeWidth: 0.965963, opacity: 1, filter: 'url(#filter1171)'}}
                  d="m 288.64277,96.393827 c -0.0211,0.436878 -3.07906,-1.313404 -3.49069,-1.165513 0.22323,1.368701 0.13957,1.838643 -0.0297,2.71652 -0.989,0.0758 -1.43666,-0.107853 -2.35263,-0.488448 -0.3605,-0.168354 -0.63384,-0.480235 -0.75345,-0.859707 -1.46172,-6.035315 -2.30006,-12.204734 -2.50184,-18.411258 -0.24712,-7.125419 0.3233,-14.255683 1.70009,-21.25119 v -0.183533 c 0.0546,-0.12106 0.13347,-0.229575 0.23183,-0.318768 0.90294,-0.802708 2.10201,-1.188372 3.3036,-1.06256 1.21496,0.02163 2.38124,0.481283 3.28427,1.294391 0.10802,0.106351 0.16444,0.254436 0.15456,0.405705 -0.42503,6.143525 -0.96597,12.673437 -1.03359,19.763607 0.0386,6.80038 1.1495,13.533144 1.48759,19.560754 z"
                  id="path27-4" />
              </g>
            </g>
            <path
              style={{fill: '#000000', fillOpacity: 1, stroke: 'none', opacity: 0.2, filter: 'url(#filter897)'}}
              className="cls-2"
              d="m 353.95427,104.14557 c 0,0 -13.97144,-9.188277 -34.48014,-1.47743 -21.76725,-7.640791 -34.48013,1.47743 -34.48013,1.47743 l 3.75065,-1.00926 0.13892,-52.23027 -3.75066,-0.06704 -0.13891,57.45006 c 20.06619,-8.505127 29.52191,-1.47237 34.26125,-0.9799 v 0 c 5.51884,-0.34432 13.43934,-7.694322 34.70935,0.87552 z"
              id="path20-3" />
          </g>
        </g>
        <path
          transform="matrix(0.96596317,0,0,0.96596317,10.571355,0.69524193)"
          style={{opacity: 0.2, filter: 'url(#filter1320)'}}
          d="m 432.1,38.05 v 7.73 h -4.87 c -2,-3.15 -7.29,-5.29 -12.59,-5.29 -11.3,0 -18.74,10.58 -18.74,25.89 v 40.77 H 387 v -72 h 8.59 v 11 c 4,-8.59 11.16,-13.74 20.31,-13.74 6.04,0.06 13.1,2.35 16.2,5.64 z"
          id="path42-2" />
        <path
          transform="matrix(0.96596317,0,0,0.96596317,10.571355,0.69524193)"
          style={{opacity: 0.2, filter: 'url(#filter1340)'}}
          d="m 463,131.61 c 8.87,0 14.74,-9.87 21.18,-24.75 L 451.12,39.48 v -4.29 h 7.72 L 488.46,96 513.06,35.2 h 7.58 v 4.29 l -27.75,68.38 c -6.44,15.59 -14.88,31 -28.75,31 a 32.19,32.19 0 0 1 -9.16,-1.43 v -7.15 a 35.44,35.44 0 0 0 8.02,1.32 z"
          id="path44-9" />
        <path
          transform="matrix(0.96596317,0,0,0.96596317,10.571355,0.69524193)"
          style={{opacity: 0.2, filter: 'url(#filter1300)'}}
          d="m 252.57,2 v 69.52 c 0,22.18 -15.73,38.2 -37.76,38.2 -22.03,0 -38.2,-16.31 -38.2,-38.91 0,-22.6 15.88,-38.81 38.06,-38.81 12.87,0 23.31,6.29 29,16.17 V 2 Z m -37.9,99.56 c 17,0 29.18,-12.87 29.32,-30.75 0.14,-17.88 -12.3,-30.62 -29.32,-30.62 -17.02,0 -29.33,12.88 -29.19,30.62 0.14,17.74 12.31,30.75 29.19,30.75 z"
          id="path40-0" />
        <path
          transform="matrix(0.96596317,0,0,0.96596317,10.571355,0.69524193)"
          style={{opacity: 0.2, filter: 'url(#filter1280)'}}
          d="M 93.43,77.820004 V 35.19 h 8.87 v 41.200004 c 0,15 9.3,25.459996 23.18,25.459996 13.59,0 23.31,-9.869996 23.31,-24.169996 V 35.19 h 8.87 v 72 h -8.87 V 96.270004 C 144.22,104.86 135.49,110.01 124.62,110.01 106,110 93.43,96.850004 93.43,77.820004 Z"
          id="path38-5" />
        <path
          transform="matrix(0.96596317,0,0,0.96596317,10.571355,0.69524193)"
          style={{opacity: 0.2, filter: 'url(#filter1260)'}}
          d="m 74.25,71 v 36.05 H 65.81 V 93.32 C 60.08,103.62 49.35,109.91 36.05,109.91 13.59,109.91 -2,94 -2,71 -2,48.4 13.74,32.23 36.05,32.23 58.36,32.23 74.25,48.4 74.25,71 Z M 6.8700002,71 C 6.8700002,88.88 19,101.76 36.05,101.76 53.1,101.76 65.38,88.88 65.38,71 65.38,53.12 53.07,40.39 36.05,40.39 19.03,40.39 6.8700002,53.26 6.8700002,71 Z"
          id="path36-2" />
        <g
          transform="matrix(0.96596317,0,0,0.96596317,10.571355,0.69524193)"
          data-name="Ebene 2"
          id="Ebene_2">
          <g
            data-name="Sicherung Komplett Buch"
            id="Sicherung_Komplett_Buch">
            <path
              id="path14"
              d="m 321.82,85.66 v 9.68 l -1.25,-3.43 A 46.41,46.41 0 0 0 314.75,81.68 31.53,31.53 0 0 0 307,74.42 L 304.77,78 a 0.52,0.52 0 0 1 -0.92,0 l -8.68,-15.64 c -0.16,-0.29 0.07,-0.66 0.36,-0.57 l 15.54,4.62 a 0.67,0.67 0 0 1 0.32,1 l -2.16,3.47 a 33.87,33.87 0 0 1 7.83,7.12 38,38 0 0 1 4.76,7.66 z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
            <path
              id="path16"
              style={{fill: PRIMARY_COLOR}}
              d="m 321.83,85.66 v 9.68 l 1.25,-3.43 a 46.41,46.41 0 0 1 5.82,-10.23 31.53,31.53 0 0 1 7.78,-7.26 l 2.2,3.54 a 0.52,0.52 0 0 0 0.92,0 l 8.68,-15.64 c 0.16,-0.29 -0.07,-0.66 -0.36,-0.57 l -15.54,4.62 a 0.67,0.67 0 0 0 -0.32,1 l 2.16,3.47 a 33.87,33.87 0 0 0 -7.83,7.16 38,38 0 0 0 -4.76,7.66 z"
              className="cls-1" />
            <path
              id="path18"
              d="m 302.28,45.13 a 30,30 0 0 1 38.65,0 37,37 0 0 1 13.67,3.07 c -6.42,-11.25 -18.32,-18.27 -33,-18.27 -14.68,0 -26.6,7.07 -32.95,18.29 a 36.84,36.84 0 0 1 13.63,-3.09 z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
            <path
              id="path20"
              d="m 355.19,50.62 c 0,0 -14.85,-10 -33.38,0 -18.53,-9.93 -33.38,0 -33.38,0 v 55.28 c 19.32,-7.24 30.54,0 33.38,0 h 0.07 c 2.8,-0.18 14,-7.25 33.32,0 z"
              className="cls-2"
              style={{fillOpacity: 1, fill: 'none', stroke: this.props.inverted ? '#ffffff' : '#000000', strokeWidth: '4.72815000000000030px',strokeOpacity: 1}} />
          </g>
          <g
            data-name="Kopfhörer NEU - sauber"
            id="Kopfhörer_NEU_-_sauber">
            <path
              id="path23"
              d="m 275.09,60.79 3.83,-2.87 a 0.31,0.31 0 0 1 0.5,0.3 87.82,87.82 0 0 0 -1.42,16.94 89.21,89.21 0 0 0 2.21,19.68 0.31,0.31 0 0 1 -0.46,0.34 c -1.25,-0.7 -2.13,-1.36 -3.36,-2.06 a 0.66,0.66 0 0 1 -0.32,-0.39 65.7,65.7 0 0 1 -1.2,-31.64 0.46,0.46 0 0 1 0.22,-0.3 z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
            <path
              id="path25"
              style={{fill: PRIMARY_COLOR}}
              d="m 283.53,97.11 c -0.85,-0.4 -2.6,-1.26 -3.22,-1.58 a 0.42,0.42 0 0 1 -0.19,-0.26 61.67,61.67 0 0 1 -1.42,-7.58 77.54,77.54 0 0 1 -1.06,-11.31 81.17,81.17 0 0 1 1.59,-18.63 0.34,0.34 0 0 1 0.16,-0.24 c 0.51,-0.27 1.14,-0.56 1.66,-0.83 0.52,-0.27 1,-0.51 1.47,-0.74 a 85.54,85.54 0 0 0 -2,20.48 82.8,82.8 0 0 0 3.35,20.31 c 0.13,0.27 -0.1,0.49 -0.34,0.38 z"
              className="cls-1" />
            <path
              id="path27"
              d="m 289.94,97 a 1.12,1.12 0 0 1 -0.74,1 5.85,5.85 0 0 1 -2.34,0.58 6.52,6.52 0 0 1 -3,-0.48 1.47,1.47 0 0 1 -0.78,-0.89 93.94,93.94 0 0 1 -2.59,-19.06 96.59,96.59 0 0 1 1.76,-22 c 0,0 0,-0.14 0,-0.19 a 1,1 0 0 1 0.24,-0.33 4.45,4.45 0 0 1 3.42,-1.1 5.22,5.22 0 0 1 3.4,1.34 0.54,0.54 0 0 1 0.16,0.42 c -0.44,6.36 -1,13.12 -1.07,20.46 0.04,7.04 1.19,14.01 1.54,20.25 z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
            <path
              id="path29"
              d="m 368.3,60.79 -3.83,-2.87 a 0.31,0.31 0 0 0 -0.5,0.3 87,87 0 0 1 1.39,16.94 88.61,88.61 0 0 1 -2.21,19.68 0.31,0.31 0 0 0 0.46,0.34 c 1.26,-0.7 2.14,-1.36 3.36,-2.06 a 0.62,0.62 0 0 0 0.32,-0.39 65.17,65.17 0 0 0 2.58,-17.73 66.36,66.36 0 0 0 -1.37,-13.88 0.52,0.52 0 0 0 -0.2,-0.33 z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
            <path
              id="path31"
              style={{fill: PRIMARY_COLOR}}
              d="m 359.86,97.11 c 0.85,-0.4 2.61,-1.26 3.22,-1.58 a 0.43,0.43 0 0 0 0.2,-0.26 60,60 0 0 0 1.41,-7.58 78.52,78.52 0 0 0 1.07,-11.31 82.33,82.33 0 0 0 -1.59,-18.63 0.35,0.35 0 0 0 -0.17,-0.24 c -0.51,-0.27 -1.13,-0.56 -1.65,-0.83 -0.52,-0.27 -1,-0.51 -1.48,-0.74 a 86,86 0 0 1 2,20.48 83.28,83.28 0 0 1 -3.35,20.31 c -0.07,0.27 0.1,0.49 0.34,0.38 z"
              className="cls-1" />
            <path
              id="path33"
              d="m 353.51,97 a 1.11,1.11 0 0 0 0.73,1 5.91,5.91 0 0 0 2.35,0.58 6.45,6.45 0 0 0 3,-0.48 1.49,1.49 0 0 0 0.79,-0.89 94.65,94.65 0 0 0 2.59,-19.06 95.93,95.93 0 0 0 -1.77,-22 c 0,0 0,-0.14 0,-0.19 a 0.88,0.88 0 0 0 -0.24,-0.33 4.45,4.45 0 0 0 -3.42,-1.1 5.24,5.24 0 0 0 -3.4,1.34 0.54,0.54 0 0 0 -0.16,0.42 c 0.45,6.36 1,13.12 1.07,20.46 -0.05,7.04 -1.19,14.01 -1.54,20.25 z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
          </g>
          <g
            data-name="Octarine light"
            id="Octarine_light">
            <path
              id="path36"
              d="m 76.25,69 v 36.05 H 67.81 V 91.32 C 62.08,101.62 51.35,107.91 38.05,107.91 15.59,107.91 0,92 0,69 0,46.4 15.74,30.23 38.05,30.23 60.36,30.23 76.25,46.4 76.25,69 Z M 8.87,69 C 8.87,86.88 21,99.76 38.05,99.76 55.1,99.76 67.38,86.88 67.38,69 67.38,51.12 55.07,38.39 38.05,38.39 21.03,38.39 8.87,51.26 8.87,69 Z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
            <path
              id="path38"
              d="M 95.43,75.82 V 33.19 h 8.87 v 41.2 c 0,15 9.3,25.46 23.18,25.46 13.59,0 23.31,-9.87 23.31,-24.17 V 33.19 h 8.87 v 72 h -8.87 V 94.27 c -4.57,8.59 -13.3,13.74 -24.17,13.74 C 108,108 95.43,94.85 95.43,75.82 Z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
            <path
              id="path40"
              d="m 254.57,0 v 69.52 c 0,22.18 -15.73,38.2 -37.76,38.2 -22.03,0 -38.2,-16.31 -38.2,-38.91 0,-22.6 15.88,-38.81 38.06,-38.81 12.87,0 23.31,6.29 29,16.17 V 0 Z m -37.9,99.56 c 17,0 29.18,-12.87 29.32,-30.75 0.14,-17.88 -12.3,-30.62 -29.32,-30.62 -17.02,0 -29.33,12.88 -29.19,30.62 0.14,17.74 12.31,30.75 29.19,30.75 z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
            <path
              id="path42"
              d="m 434.1,36.05 v 7.73 h -4.87 c -2,-3.15 -7.29,-5.29 -12.59,-5.29 -11.3,0 -18.74,10.58 -18.74,25.89 v 40.77 H 389 v -72 h 8.59 v 11 c 4,-8.59 11.16,-13.74 20.31,-13.74 6.04,0.06 13.1,2.35 16.2,5.64 z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
            <path
              id="path44"
              d="m 465,129.61 c 8.87,0 14.74,-9.87 21.18,-24.75 L 453.12,37.48 v -4.29 h 7.72 L 490.46,94 515.06,33.2 h 7.58 v 4.29 l -27.75,68.38 c -6.44,15.59 -14.88,31 -28.75,31 a 32.19,32.19 0 0 1 -9.16,-1.43 v -7.15 a 35.44,35.44 0 0 0 8.02,1.32 z"
              style={{fillOpacity: 1, fill: this.props.inverted ? '#ffffff' : '#000000'}} />
          </g>
        </g>
      </svg>
    );
  }
}


export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo.js